import { render, staticRenderFns } from "./interviewDetail.vue?vue&type=template&id=63b718b3&scoped=true"
import script from "./interviewDetail.vue?vue&type=script&lang=js"
export * from "./interviewDetail.vue?vue&type=script&lang=js"
import style0 from "./interviewDetail.vue?vue&type=style&index=0&id=63b718b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b718b3",
  null
  
)

export default component.exports